import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import {UserModel} from '@/user/models/UserModel'

export default {
    getUserAuthenticated():Promise<UserModel> {
        return axios.get(`${API_ADMIN}users/authenticated`)
            .then(({data}) => {
                return new UserModel(data)
            })
    },
}
